import type { WidgetConfig } from '../hooks/useFetchWidgetConfig';

export type LauncherTeaserMode = 'none' | 'pulse' | 'message';

export function getLauncherTeaserMode(config: WidgetConfig['customization'] | undefined): LauncherTeaserMode {
  if (!config?.launcherTeaserEnabled) return 'none';
  return config.launcherTeaserStyle === 'pulse' ? 'pulse' : 'message';
}
